import Flatpickr from 'stimulus-flatpickr'

// Inline Flatpickr calendar for the community class schedule panel.
export default class extends Flatpickr {
  initialize() {
    this.config = {
      inline: true,
      enableTime: false,
      monthSelectorType: 'static',
      dateFormat: 'Y-m-d',
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        }
      }
    }
  }

  change() {
    this.element.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
